'use strict';

angular.module('amexReconciliationApp')
  .service('AccountingCodeValueRepository',
    function AccountingCodeValueRepository($resource) {
      var self = this;

      self.getAccountingCodes = function (params) {
        var accountingCodeResource = $resource(
          '/api/v1/companies/:companyId/sites/:siteNumber/schema/:schemaPosition/allValidValues', {},
          {
            'get': {method: 'GET', isArray: true}
          }
        );

        return accountingCodeResource.get(
          { companyId: params.companyId,
            siteNumber: params.siteNumber,
            schemaPosition: params.schema.position,
            searchString: params.searchString,
            comboPositions: params.comboPositions,
            comboValues: params.comboValues
          }).$promise;
      };

      self.getTotalNumberOfAccountingCodes = function (params) {
        var accountingCodeResource = $resource(
          '/api/v1/companies/:companyId/sites/:siteNumber/schema/:schemaPosition/countValidValues', {},
          {
            'get': {method: 'GET', isArray: true}
          }
        );

        return accountingCodeResource.get(
          { companyId: params.companyId,
            siteNumber: params.siteNumber,
            schemaPosition: params.schema.position,
            validationComboPosition: params.schema.validationComboPosition,
            comboId: params.schema.validationComboId,
            comboPositions: params.comboPositions,
            comboValues: params.comboValues
          }).$promise;
      };

      self.getDescription = function (params) {
        var accountingCodeResource = $resource(
          '/api/v1/companies/:companyId/sites/:siteNumber/schema/:schemaPosition/description', {},
          {
            'get': {method: 'GET', isArray: true}
          }
        );

        return accountingCodeResource.get(
          { companyId: params.companyId,
            siteNumber: params.siteNumber,
            schemaPosition: params.schema.position,
            searchString: params.searchString
          }).$promise;
      };



    });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/AccountingCodeValueRepository.js
// module id = 598
// module chunks = 0